import React, { Fragment } from 'react';
import { MainLayout } from '../MainLayout';
import { PagesHeader } from '../shared/PagesHeader';
import { TilesWrapper } from '../shared/TilesWrapper';
import { Tile } from '../shared/Tile';
import { PageTile } from '../PageTile';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';
import './Dashboard.css';

const Dashboard = ({
  title,
  subtitle,
  withBreadcrumb,
  withActionButton,
  action,
  routes,
  pages,
  isEInvoicing,
  tileId,
  isTaxReturn,
  withoutTiles,
  children,
  wrapperClassName,
}) => {
  const { t } = useTranslation();
  const history = useNavigate();

  return (
    <MainLayout eInvoicing={isEInvoicing}>
      <PagesHeader
        title={title}
        withBreadcrumb={withBreadcrumb}
        withActionButton={withActionButton}
        action={action}
        routes={routes}
        isTaxReturn={isTaxReturn}
        wrapperClassName={tileId + '-page-header'}
      >
        {children}
      </PagesHeader>
      {withoutTiles && (
        <TilesWrapper
          className={classNames(
            'flex-column p-md-0 p-5 w-100 dashboard-buttons-wrapper',
          )}
        >
          {subtitle}
          {pages.map(
            (page, i) =>
              !page.hide && (
                <Button
                  key={page.title}
                  label={t(page.title)}
                  icon="pi pi-arrow-right dir"
                  iconPos="right"
                  className="dashboard-nav-button"
                  disabled={page.disabled}
                  onClick={() =>
                    history(`${page.redirectUrl}`, {
                      replace: false,
                      relative: true,
                    })
                  }
                />
              ),
          )}
        </TilesWrapper>
      )}
      {!withoutTiles && (
        <TilesWrapper
          className={classNames(
            'flex-row flex-md-row p-md-0 p- gap-5',
            wrapperClassName,
          )}
        >
          {pages.map(
            (page, i) =>
              !page.hide && (
                <Fragment key={tileId + i}>
                  <Tile id={tileId + i}>
                    <PageTile
                      redirectUrl={page.redirectUrl}
                      iconName={page.iconName}
                      title={t(page.title)}
                      description={t(page.description)}
                      buttonName={t(page.buttonName)}
                      disabled={page.disabled}
                    />
                  </Tile>
                  {i < pages.length - 1 && (
                    <div
                      className="vr p-0 mx-3 d-none d-md-block"
                      style={{ maxHeight: '400px' }}
                    />
                  )}
                </Fragment>
              ),
          )}
        </TilesWrapper>
      )}
    </MainLayout>
  );
};

export default React.memo(Dashboard);
